// ispencil/ispencilui.js

import { Plugin, ButtonView, createDropdown, SplitButtonView } from 'ckeditor5';
/*
import leftPosIcon from '../theme/icons/ispcl-i-floatleft.svg';
import centerPosIcon from '../theme/icons/ispcl-i-center.svg';
import rightPosIcon from '../theme/icons/ispcl-i-floatright.svg';
import pencilIcon from '../theme/icons/pencil.svg';
import IsPencilToolbar from './ispenciltoolbar';
import IsCmdPanel from './ispen/iscmdpanel';
*/

import IsCanvas from './ispen/iscanvas';
import IsPencilToolbar from './ispenciltoolbar';
import IsCmdPanel from './ispen/iscmdpanel';

const pencilIcon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>';       
const leftPosIcon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>';
const centerPosIcon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>';
const rightPosIcon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>';

export default class IsPencilUI extends Plugin {

    static get pluginName() {
		return 'IsPencilUI';
	}
    
    static get requires() {
        return [ IsPencilToolbar ];
    }

    init() {
        // console.log( 'IsPencilUI#init() got called' );
        
        const editor = this.editor;
        const t = editor.t;
        const isCanvas = editor.plugins.get( IsCanvas );
        const isPencilToolbar = editor.plugins.get( IsPencilToolbar );

        /**
         * Factpry for isPencilCocpit. This is a dropdown panel, offering a split button with:
         *      - a button to insert a new IsPencil widget
         *      - a dropdown panel with several buttons to customize the mode (draw, draw straigt lines, erase) and the pen (color, width)
         * isPencilInsertCommand is define in plugin IsPencilInsertCommand and registered in IsPencilEditing#Init.
         */
        editor.ui.componentFactory.add( 'isPencil', locale => {
            const dropdown = createDropdown( locale, SplitButtonView );
            // At this point, we should not used the unqualified buttonView, since it duplicates to both buttons action and arrow
            dropdown.buttonView.actionView.set( {
                label: t( 'IsPencil' ),
                icon: pencilIcon,
                tooltip: true
            } );
            // dropdown.bind('isEnabled').to(command);
            dropdown.buttonView.actionView.on( 'execute', () => editor.execute( 'isPencilInsertCommand' ) );
            // console.log( 'dropdown', dropdown );
            const commandPanelView = new IsCmdPanel( locale, dropdown );
            dropdown.panelView.children.add( commandPanelView );
            // console.log( 'commandPanelView', commandPanelView );
            this.listenTo(commandPanelView, 'change:mode', () => isCanvas.changeMode(commandPanelView.mode ) );
            this.listenTo(commandPanelView, 'change:color', () => isCanvas.changeColor(commandPanelView.color ) );
            this.listenTo(commandPanelView, 'change:stroke', () => isCanvas.changeStroke(commandPanelView.stroke ) );
            return dropdown;
        } );

        /**
         * The following are the buttons for the widget baloon toolbar
         * They show the current style of the related widget, by highlighting the corresponding icon.
         * This is achieved, by binding the icon view's isOn to the properties *.PosActive of IsPencilToolbar
         */
        editor.ui.componentFactory.add( 'isPencilLeft', locale => {
            const buttonView = new ButtonView( locale );

            buttonView.set( {
                label: t( 'isPencil float left' ),
                icon: leftPosIcon,
                tooltip: true
            } );
            buttonView.bind( 'isOn' ).to( isPencilToolbar, 'leftPosActive' );
            this.listenTo( buttonView, 'execute', () => editor.execute( 'isPencilPosCommand', 'left' ) );
            return buttonView;
        } );

        
         editor.ui.componentFactory.add( 'isPencilCenter', locale => {
            const buttonView = new ButtonView( locale );

            buttonView.set( {
                label: t( 'isPencil center' ),
                icon: centerPosIcon,
                tooltip: true
            } );
            buttonView.bind( 'isOn' ).to( isPencilToolbar, 'centerPosActive' );
            // Execute the command when the button is clicked
            this.listenTo( buttonView, 'execute', () => editor.execute( 'isPencilPosCommand', 'center' ) );
            return buttonView;
        } );


        editor.ui.componentFactory.add( 'isPencilRight', locale => {
            const buttonView = new ButtonView( locale );

            buttonView.set( {
                label: t( 'isPencil float right' ),
                icon: rightPosIcon,
                tooltip: true
            } );
            buttonView.bind( 'isOn' ).to( isPencilToolbar, 'rightPosActive' );
            this.listenTo( buttonView, 'execute', () => editor.execute( 'isPencilPosCommand', 'right' ) );
            return buttonView;
        } );

        // console.log('Terminated IsPencilUI#init');
    }

}